import { GlobalStateContext } from "../components/providers/GlobalStateProvider"
import { useContext } from "react"
import { auth } from "../firebase.js"

export function useAuthenticatedFetch() {
	const { state } = useContext(GlobalStateContext)

	return async (uri, options = {}) => {
		const idToken = await auth.currentUser.getIdToken()
		const response = await fetch(uri, {
			...options,
			headers: {
				"Content-Type": "application/json",
				...options.headers,
				"X-Kopy-Shop": state.shop,
				"X-Kopy-Access-Token": state.accessToken,
				"X-Kopy-User-Id": state.userId,
				Authorization: `Bearer ${idToken}`,
			},
		}).catch((err) =>
			console.error("[useAuthenticatedFetch] Catched error", err),
		)

		return response
	}
}
